module.exports = __webpack_public_path__ + "static/media/fybr-logo.942851b6.svg";